import React from 'react';
import './main.css';
import { Grid, Box } from '@mui/material';
import ModuleViewer from './ModuleViewer';

/**
 * The Main component is the top-level component of the application.
 * It renders a Grid container with a single Grid item that takes up the full width on small screens and 3/4 of the width on medium and larger screens.
 * The Grid item contains a Box component that wraps the ModuleViewer component.
 * The ModuleViewer component is passed two props: `selectedModules` and `module`, which are expected to be arrays and objects, respectively.
 *
 * @param {object} props - The props object
 * @param {array} props.selectedModules - An array of selected modules
 * @param {object} props.module - The current module object
 *
 */

function Main(props) {
  return (
    <Box className='ContainerMain'>

      <Grid container spacing={4} sx={{ height: '100%', width: '100%' }}>
        <Grid item xs={12} md={9}>
          <Box  className='Main' sx={{ width: '90%', height: '90vh' }}>
            <ModuleViewer selectedModules={props.selectedModules}  />
          </Box>
        </Grid>
      </Grid>

    </Box>
  );
}

export default Main;
